import React, { useCallback } from "react";
import MessageBubbleGroup from "Modules/chat/components/MessageBubbleGroup";
import MessageBubble from "Modules/chat/components/MessageBubble";
import { AIMessageBubbleType } from "../constants";
import LoadingDots from "./LoadingDots";
import MarkdownRenderer from "Components/MarkdownRenderer";
import { Typography, CircularProgress, Box } from "@mui/material";
import { CSSTransition, SwitchTransition } from 'react-transition-group';

const StageBubble = ({ item, translated = {}, useTranslated = true }) => {
  const nodeRef = React.useRef(null); // passing ref onto CSSTransition to avoid deprecate
  const transitionKey = item.messageStage || "stop";

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        nodeRef={nodeRef}
        key={transitionKey}
        timeout={300}
        classNames="ai-message-fade"
      >
        <Box ref={nodeRef}>
          <CircularProgress className="loading-spinner" size={16}/>
          {/*TODO: FE handle stage event message translations until BE can support*/}
          <span className="stage-text">{useTranslated ? translated[`agent_stage_${item.messageStage}`] : item.message}</span>
        </Box>
      </CSSTransition>
    </SwitchTransition>
  );
};

const AIChatMessages = ({
  translated,
  groupedMessages = [],
  handleSubmitQuestion = () => {},
  handleRetryPrompt = () => {},
  isStreaming = false,
}) => {

  const buildMessageContent = useCallback((item) => {
    const message = item.message || "";
    const bubbleType = item.bubbleType || "text";
    switch (bubbleType) {
      case AIMessageBubbleType.LOADING_DOTS:
        return <LoadingDots />;

      case AIMessageBubbleType.SUGGESTION:
        return <Typography variant="body1" component="div" onClick={() => handleSubmitQuestion(message)}>
          <MarkdownRenderer>{message}</MarkdownRenderer>
        </Typography>;
      
      case AIMessageBubbleType.STAGE:
        return <StageBubble item={item} translated={translated} />;
      
      case AIMessageBubbleType.THINKING:
        return <StageBubble item={item} useTranslated={false}/>;
      
      case AIMessageBubbleType.TRY_AGAIN:
        // Parse message to extract text before and after "try again"
        const tryAgain = translated['agent_stage_try_again'] || 'try again';
        const parts = translated['agent_stage_ERROR'].split(tryAgain);
        return (
          <Typography variant="body1" component="div" fontSize={14}>
            {parts[0]}
            <span 
              className={`try-again-link ${isStreaming ? 'disabled' : ''}`}
              onClick={() => {
                if (!isStreaming) {
                  handleRetryPrompt({errorItem: item})
                }
              }}
            >
              {tryAgain}
            </span>
            {parts[1]}
          </Typography>
        );

      default: // TEXT type
        return (
          <Typography variant="body1" component="div">
            <MarkdownRenderer>{message}</MarkdownRenderer>
          </Typography>
        );
    }
  }, [translated, handleSubmitQuestion, handleRetryPrompt, isStreaming]);

  return <>
    {groupedMessages.map((group, groupIndex) => (
      <MessageBubbleGroup
        key={`ai-message-group-${groupIndex}`}
        isIncomingMessage={group.sender === "bot"}
        isShowAvatar={group.sender === "bot"}
        avatarUrl="/assets/icons/chat/ai.svg"
        wrapperCssClasses="chat-type-ai"
      >
        {group.items.map((item, itemIndex) => (
          <MessageBubble
            key={`ai-message-bubble-${groupIndex}-${itemIndex}`}
            messageContent={buildMessageContent(item)}
            wrapperCssClasses={item.bubbleType || "text"}
          />
        ))}
      </MessageBubbleGroup>
    ))}
  </>
};

// Memoize component to prevent unnecessary re-renders
export default React.memo(AIChatMessages);
